module.exports = __webpack_public_path__ + "static/media/bw_fintech_award_2024.1d6aa247.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bw_fintech_award_2024.webp
// module id = 361
// module chunks = 0